/* Mayfly Studios - percentage discount badges.
 *
 * Horizon renders a sale badge reading "Sale" from a platform-provided block
 * (_product-card-gallery) that is not part of the theme files, so the text
 * cannot be changed in Liquid. Rather than install a paid badge app, read the
 * prices already printed on each card, work out the discount and relabel the
 * badge in place. Sold-out badges are left alone.
 */
(function () {
  if (typeof window === 'undefined') return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  // Pull every currency-looking number out of an element. "Rs. 1,200.00" -> 1200
  function numbers(el) {
    var found = el.textContent.match(/\d[\d,]*(?:\.\d+)?/g) || [];
    var out = [];
    for (var i = 0; i < found.length; i++) {
      var n = parseFloat(found[i].replace(/,/g, ''));
      if (!isNaN(n) && n > 0) out.push(n);
    }
    return out;
  }

  function relabel(scope) {
    var badges = (scope || document).querySelectorAll('.product-badges__badge');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];

      // Never touch "Sold out" - that is not a discount.
      if (/sold/i.test(badge.textContent)) continue;
      if (/%/.test(badge.textContent)) continue;

      var card = badge.closest('product-card, .product-card, .product-grid__item, li');
      if (!card) continue;

      var priceEl = card.querySelector('product-price, .price');
      if (!priceEl) continue;

      var values = numbers(priceEl);
      if (values.length < 2) continue;

      var sale = Math.min.apply(null, values);
      var was = Math.max.apply(null, values);
      if (was <= sale) continue;

      var pct = Math.round(((was - sale) / was) * 100);
      if (pct < 1 || pct > 99) continue;

      badge.textContent = pct + '% OFF';
    }
  }

  ready(function () {
    relabel();

    // Filtering, sorting and infinite scroll replace grid contents, so re-run.
    var grid = document.querySelector('.product-grid, results-list');
    if (grid && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { relabel(); }, 60);
      }).observe(grid, { childList: true, subtree: true });
    }
  });
})();
